export const environment = {
    production: false,
    staging: true,
    apiUrl: 'https://api.chauffeurprodriver.com',
    appUrl: 'https://dashboard.chauffeurprodriver.com',
    googleMapsApiKey: 'AIzaSyArZUkxEJGI4tijMiX5RUXQnlgmHvZU-AU',
    version: '1.0.0',
    buildNumber: '20261105-170950-ef16db2',
};
